export default __webpack_public_path__ + "static/attest_online-c1c079222aae873b98ecdc8352ad834f.png";